// extracted by mini-css-extract-plugin
export default {"wrapper":"Bl8RH","banners-container":"jEVcD","title":"lH8dj","text":"T02AW","right-banners":"scyo7"};